import { FC } from "react";
import { Spacer } from "shared/layout";
import {
  BodyPreferences,
  HotelPreferences,
  FlightPreferences,
  LoyaltyPrograms,
} from "./containers";

export const EditPreferencesPage: FC = () => {
  return (
    <Spacer size="m">
      <BodyPreferences />
      <HotelPreferences />
      <FlightPreferences />
      <LoyaltyPrograms />
    </Spacer>
  );
};
